<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          @click="handleStep('EVOLUCAO')"
          :class="[
            'nav-link link-nav-resident',
            step == 'EVOLUCAO' && 'active',
          ]"
          id="nav-evolucao"
          data-toggle="tab"
          href="#evolucao"
          role="tab"
          aria-controls="evolucao"
          aria-selected="true"
          >EVOLUÇÃO TERAPEUTA OCUPACIONAL</a
        >
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="step == 'EVOLUCAO'"
        :class="['tab-pane fade', step == 'EVOLUCAO' && 'show active']"
        id="evolucao"
        role="tabpanel"
        aria-labelledby="nav-evolucao"
      >
        <Evolution />
      </div>
    </div>
  </div>
</template>

<script>
import Evolution from "./OccupationalTherapist/Evolution";

import routes from "../../routes";

import { userData } from "../../lib/functions";

export default {
  name: "MenuOccupationalTherapist",
  components: {
    Evolution,
  },
  data() {
    return {
      step: "EVOLUCAO",
      rest_home_id: "",
      resident_id: "",
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    handleStep(step) {
      let newNav;

      if (step == "EVOLUCAO") {
        newNav = "evolution";
      }

      let { tab, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, nav: newNav } });
      }

      this.step = step;
    },
    async retrieve() {
      let { rest_home_id } = userData();

      this.rest_home_id = rest_home_id;

      const { id } = routes.history.current.params;

      this.resident_id = id;

      const { nav } = routes.history.current.query;

      if (nav) {
        if (nav == "evolution") {
          this.step = "EVOLUCAO";
        }
      }
    },
  },
};
</script>
